import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme: Theme) => ({
  buttonContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(1),
    borderRadius: theme.spacing(1),
  },
  datePickerContainer: {
    borderRadius: theme.spacing(1),
    overflow: 'hidden',
    position: 'absolute',
    boxShadow: theme.shadows[2],
    zIndex: 2,
  },
}));
